<div class="dialog-alert" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
    <button class="dialog-alert-close" mat-dialog-close fxFlexAlign="end" type="button" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>

    <h3>{{ "ENTER_NEW_EMAIL" | translate }}</h3>

    <mat-form-field appearance="outline">
        <mat-label>{{ "EMAIL" | translate }}</mat-label>
        <input [formControl]="emailControl" matInput [placeholder]="'EMAIL' | translate" />
    </mat-form-field>

    <button mat-flat-button color="primary" class="my-button" (click)="onSubmit()">
    {{ "CONTINUE" | translate }}
  </button>
</div>